<template>
  <div class="navbar">
    <p class="navbar-content">
      Central de atendimento:
      <a class="navbar-content__link" :href="'tel:+55 11' + tel">{{ tel }}</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  props: ['tel']
};
</script>

<style lang="scss">
.navbar {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-positive-normal);
  color: var(--color-white);
  text-align: center;

  &-content {
    margin: 0;
    font-size: 16px;

    &__link {
      color: var(--color-white);
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
